/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        LinkRiotAccountRequest,
        LinkRiotAccountResponse,
    } from '../models/index';

            export interface LinkRiotAccountCreateRequest {
                link_riot_account_request: LinkRiotAccountRequest;
            }

        /**
        * 
        */
            export class RiotAccountApi extends runtime.BaseAPI {

            /**
                * Link the authenticated user\'s account to their Riot Games identity.  The frontend redirects the user to Riot\'s authorization page. After the user authorizes, the frontend receives an authorization code and sends it here. The backend then:  1. Exchanges the authorization code for access / refresh tokens via the    Riot RSO token endpoint. 2. Uses the access token to retrieve the player\'s PUUID, game name and    tagline from the Riot Account API. 3. Persists everything on the ``AuthUser`` model for later use (e.g. fetching    match history, including private games).
            */
            async linkRiotAccountCreateRaw(requestParameters: LinkRiotAccountCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LinkRiotAccountResponse>> {
                    if (requestParameters.link_riot_account_request === null || requestParameters.link_riot_account_request === undefined) {
                    throw new runtime.RequiredError('link_riot_account_request','Required parameter requestParameters.link_riot_account_request was null or undefined when calling linkRiotAccountCreate.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/LinkRiotAccount`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.link_riot_account_request,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
                * Link the authenticated user\'s account to their Riot Games identity.  The frontend redirects the user to Riot\'s authorization page. After the user authorizes, the frontend receives an authorization code and sends it here. The backend then:  1. Exchanges the authorization code for access / refresh tokens via the    Riot RSO token endpoint. 2. Uses the access token to retrieve the player\'s PUUID, game name and    tagline from the Riot Account API. 3. Persists everything on the ``AuthUser`` model for later use (e.g. fetching    match history, including private games).
            */
                async patch(requestParameters: LinkRiotAccountCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LinkRiotAccountResponse> {
                    const response = await this.linkRiotAccountCreateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
